import React, { useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

export function CustomerCombobox({ value, onChange, options = [], placeholder = "Select or type a customer" }) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const triggerRef = useRef(null);
    const [contentWidth, setContentWidth] = useState(0);

    useEffect(() => {
        if (open && triggerRef.current) {
            setContentWidth(triggerRef.current.offsetWidth || 0);
        }
    }, [open]);

    useEffect(() => {
        setSearch(value || "");
    }, [value]);

    const selectValue = (val) => {
        if (!val) return;
        onChange?.(val);
        setOpen(false);
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div
                    ref={triggerRef}
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className={cn(
                        "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                    )}>
                    <span className="truncate">
                        {value ? (
                            value
                        ) : (
                            <span className="text-muted-foreground">{placeholder}</span>
                        )}
                    </span>
                    <ChevronDown className="h-4 w-4 opacity-50" />
                </div>
            </PopoverTrigger>
            <PopoverContent align="start" sideOffset={4} className="z-50 p-0" style={{ width: contentWidth || undefined }}>
                <Command>
                    <CommandInput
                        value={search}
                        onValueChange={setSearch}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                const input = search.trim();
                                if (input) selectValue(input);
                            }
                        }}
                        placeholder="Type to search or add new"
                    />
                    <CommandList>
                        <CommandEmpty>No results</CommandEmpty>
                        {search && !options.some((o) => o.toLowerCase() === search.trim().toLowerCase()) && (
                            <CommandGroup heading="Create">
                                <CommandItem value={search} onSelect={() => selectValue(search.trim())}>
                                    Use "{search.trim()}"
                                </CommandItem>
                            </CommandGroup>
                        )}
                        <CommandGroup heading="Customers">
                            {options.map((opt) => (
                                <CommandItem key={opt} value={opt} onSelect={() => selectValue(opt)}>
                                    {opt}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}